import React, { Component } from "react";
import { connect } from "react-redux";
import "./Profile.scss";
import {
    UpdateUserDetails,
    UpdateCompanyDetails,
    UploadPhoto,
    switchAccountDetails,
    fetchMetaData,
    isSwitchCompanyAvailable,
} from "../../../actions/globalAction";
import moment from "moment";
import { Input, Dropdown, Checkbox, Icon, Popup } from "semantic-ui-react";
import Select, { components } from "react-select";
import { toast } from "react-toastify";
import { ReactComponent as SearchIcon } from "../../../assets/svg/search.svg";
import { ReactComponent as CloseIcon } from "../../../assets/svg/close.svg";
import { ReactComponent as EyeClose } from "../../../assets/svg/password-hide.svg";
import { ReactComponent as EyeOpen } from "../../../assets/svg/password-show.svg";
import Modal from "../../UIComponents/CustomModal/Modal";
import { timezones } from "../../../lib/timezones";

class Profile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            companyImage: props.getUrl,
            companyName: props.company.company_name !== "" ? props.company.company_name : props.company.company_identifier,
            profileName: props.company.user_name,
            userName: props.userName,
            email: props.userEmail,
            password: "*******",
            showNewPassword: false,
            autopush_post_type: props.auto_push_enabled,
            // timezone: Number.parseFloat(props.company.user_timezone).toFixed(1),
            timezone: this.fetchTimezone(),
            isEditEnabled: false,
            hasPasswordChanged: false,
            imageFile: null,
            showModal: false,
            selectedAccount: "",
            searchCompany: "",
            linked_companies: [],
            interactiveHelp_enabled: this.props.interactive_help_enabled,
        };
        this.hiddenFileInput = React.createRef();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.newAccessToken !== this.props.newAccessToken && this.props.newAccessToken) {
            sessionStorage.setItem("accountChanged", true);
            history.go(0);
        }
        if (prevProps.all_companies !== this.props.all_companies && this.props.all_companies) {
            let linked_companies = [];
            if (this.props.all_companies && this.props.all_companies.length > 1) {
                this.props.all_companies.map((x) => {
                    let name = x.name ? x.name : x.company_identifier;
                    if (!linked_companies.some((e) => e.name === name)) linked_companies.push({ name, id: x.lite_company_id });
                });
            }
            linked_companies = linked_companies.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
            this.setState({ linked_companies });
        }
        if (prevProps.interactive_help_enabled !== this.props.interactive_help_enabled) {
            console.log("interactive_help_enabled", this.props.interactive_help_enabled);
            this.setState({ interactiveHelp_enabled: this.props.interactive_help_enabled });
        }
    }

    componentDidMount() {
        if (sessionStorage.getItem("accountChanged")) {
            toast.success("Successfully logged into the New Account");
            sessionStorage.removeItem("accountChanged");
        }
        let linked_companies = [];
        if (this.props.all_companies && this.props.all_companies.length > 1) {
            this.props.all_companies.map((x) => {
                let name = x.name ? x.name : x.company_identifier;
                if (!linked_companies.some((e) => e.name === name)) linked_companies.push({ name, id: x.lite_company_id });
            });
        }
        linked_companies = linked_companies.sort(function (a, b) {
            return a.name.localeCompare(b.name);
        });
        this.setState({ linked_companies });
    }

    handleChange(e, label) {
        if (label == "companyName" && e.target.value.toString().length == 40) {
            toast.error("Company name should not be more than 40 characters");
        }
        this.setState({
            [label]: e.target.value,
        });
    }

    fetchTimezone = () => {
        const receivedTimezone = this.props.company.user_timezone_name;
        let initialTimezone = receivedTimezone === "UTC" || "" || undefined ? moment.tz.guess(true) : this.props.company.user_timezone_name;

        let countryArr = timezones.filter((timezoneObj) => timezoneObj.utc.includes(initialTimezone));

        return { label: countryArr[0]?.text.split(" ")[0] + " " + initialTimezone, value: countryArr[0]?.text.split(" ")[0] + " " + initialTimezone };
    };

    fetchTimezoneOffset = () => {
        let countryArr = timezones.filter((timezoneObj) => timezoneObj.utc.includes(this.state.timezone.label.split(" ")[1]));
        return countryArr[0]?.offset;
    };

    fetchTimezoneList = () => {
        let list = [];
        timezones.map((timezone) => {
            let offset = timezone.text.split(" ")[0];
            timezone.utc.map((entry) => list.push({ label: offset + " " + entry, value: offset + " " + entry }));
        });
        return list;
    };

    handleDropDownChange = (e) => {
        this.setState({
            timezone: { label: e.label, value: e.value },
        });
    };

    handleClick = (event) => {
        this.hiddenFileInput.current.click();
    };

    handleFileChange = (event) => {
        let selectedFile = event.target.files;
        this.props.UploadPhoto(selectedFile[0]);
        let file = null;
        let fileName = "";

        if (selectedFile.length > 0) {
            let fileToLoad = selectedFile[0];
            fileName = fileToLoad.name;

            let fileReader = new FileReader();

            const storeFile = (file) => {
                this.setState({
                    companyImage: file,
                });
            };

            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                file = fileLoadedEvent.target.result;
                storeFile(file);
            };

            // Convert data to base64
            fileReader.readAsDataURL(fileToLoad);
        }
    };

    onClickCheckBoxes = (checkType) => {
        this.setState({
            autopush_post_type: checkType,
        });
    };

    onSave = () => {
        if (this.state.companyName == "") {
            toast.error("Company name can not be blank");
            return;
        }

        if (this.state.companyName.length <= 2) {
            toast.error("Company name should be atleast 3 characters long");
            return;
        }

        let saveData = {
            name: this.state.profileName,
            autopush_post_type: this.state.autopush_post_type ? "2" : "1",
            timezone: this.fetchTimezoneOffset(),
            timezone_name: this.state.timezone.label.split(" ")[1],
            interactive_help_enabled: this.state.interactiveHelp_enabled ? 1 : 0,
        };

        localStorage.setItem("interactive_help_enabled", this.state.interactiveHelp_enabled ? 1 : 0);

        let companyDetails = {
            name: this.state.companyName,
        };

        if (this.state.password !== "*******") {
            const passwordRegex = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;

            if (this.state.password === "") {
                toast.error("Please enter a password");
                return;
            } else if (this.state.password === this.props.userName || this.state.password === this.props.company.user_name) {
                toast.error("Password cannot be the same as User name.");
                return;
            } else if (this.state.password === this.props.userEmail) {
                toast.error("Password cannot be the same as E-mail.");
                return;
            } else if (this.state.password.length < 8 || this.state.password.length > 30) {
                toast.error("Password criteria is not fullfilled.");
                return;
            } else if (!passwordRegex.test(this.state.password)) {
                toast.error("Password criteria is not fullfilled.");
                return;
            } else {
                saveData.password = this.state.password;
            }
        }

        if (this.props.imageUploadedUrl) {
            saveData.image = this.props.imageUploadedUrl;
        }
        this.props.UpdateUserDetails(saveData);
        this.props.UpdateCompanyDetails(companyDetails);
        this.setState({
            isEditEnabled: !this.state.isEditEnabled,
        });
    };

    showNewPassword = () => {
        this.setState({ showNewPassword: !this.state.showNewPassword });
    };

    setSwitchModal = (show) => {
        this.setState({
            ...this.state,
            showModal: show,
        });
    };

    renderSwitchModal = () => {
        let company_id =
            this.props.all_companies.find((c) => (c.name || c.company_identifier) == this.state.selectedAccount.toString()) &&
            this.props.all_companies.find((c) => (c.name || c.company_identifier) == this.state.selectedAccount.toString()).id;
        let company_name = this.props.company.user_name;

        return (
            <Modal show={this.state.showModal} onClose={() => this.setSwitchModal(false)}>
                <Modal.Header>Switch Company</Modal.Header>
                <Modal.Content style={{ textAlign: "center" }}>
                    Are you sure you want to switch the company from <br />
                    <b>{this.truncatedName(this.state.companyName.split(""))}</b> <br /> to <br />
                    <b>{this.truncatedName(this.state.selectedAccount.split(""))}</b> ?
                </Modal.Content>
                <Modal.Actions>
                    <Modal.ActionButton className="block-button" normal onClick={() => this.setSwitchModal(false)}>
                        Cancel
                    </Modal.ActionButton>
                    <Modal.ActionButton
                        className="block-button"
                        filled
                        onClick={() => {
                            this.props.switchAccountDetails(company_id);
                            this.setSwitchModal(false);
                            localStorage.removeItem("activeModule");
                        }}>
                        Switch
                    </Modal.ActionButton>
                </Modal.Actions>
            </Modal>
        );
    };

    searchCompanyName = (e) => {
        this.setState({
            searchCompany: e.target.value,
        });
    };

    filteredSearch = (linked_companies) => {
        if (this.state.searchCompany == "") return linked_companies;
        if (this.state.searchCompany.length == 1) {
            let filtered_companies = linked_companies.filter((c) => c.name.toLowerCase().charAt(0) == this.state.searchCompany.toLowerCase());
            if (filtered_companies.length) {
                return filtered_companies;
            } else {
                return [{ name: "No company found" }];
            }
        } else {
            let filtered_companies = linked_companies.filter((c) => c.name.toLowerCase().includes(this.state.searchCompany.toLowerCase()));
            if (filtered_companies.length) {
                return filtered_companies;
            } else {
                return [{ name: "No company found" }];
            }
        }
    };

    fullName = (name) => {
        return <div className="full-name">{name.join("")}</div>;
    };

    truncatedName = (text) => {
        let name = text;
        if (name.length > 40) {
            name = name.join("").substring(0, 40 - 3) + "...";
            return name;
            //    return <Popup inverted trigger={<span className="full-name-popup">{name}</span>} content={() => this.fullName(text)} position="right center" />;
        } else {
            return text.join("");
        }
    };

    render() {
        const { timezone, autopush_post_type, email } = this.state;

        let company_id = this.props.company.company_id;
        let company_name = this.props.company.user_name;

        if (this.state.linked_companies && this.state.linked_companies.length) this.props.isSwitchCompanyAvailable(true);

        const IndicatorsContainer = ({ children, ...props }) => {
            return (
                <components.IndicatorsContainer {...props}>
                    <div className="react-select-control">
                        {children}
                        {/* <p>hello</p> */}
                        {this.state.isEditEnabled ? <Icon name={"caret right"} size="large" /> : null}
                    </div>
                </components.IndicatorsContainer>
            );
        };

        const customStyles = {
            control: (styles) =>
                !this.state.isEditEnabled
                    ? {
                          ...styles,
                          backgroundColor: "transparent",
                          width: "90%",
                          paddingLeft: "3%",
                          marginLeft: "10%",
                          paddingTop: "6px",
                          paddingBottom: "6px",
                          border: "none",
                      }
                    : {
                          ...styles,
                          backgroundColor: "#EFF5FC",
                          width: "90%",
                          paddingLeft: "3%",
                          marginLeft: "10%",
                          paddingTop: "6px",
                          paddingBottom: "6px",
                          border: "none",
                      },

            valueContainer: (provided, state) => ({
                backgroundColor: !this.state.isEditEnabled ? "transparent" : "#EFF5FC",
            }),
        };

        return (
            <div className="ProfileContent profile_step1">
                <div className="ProfileSub">
                    <div className="image-view" style={this.state.isEditEnabled ? { cursor: "pointer" } : {}}>
                        <img
                            onClick={this.state.isEditEnabled ? this.handleClick : null}
                            src={this.state.companyImage ? this.state.companyImage : `${process.env.PUBLIC_URL}/profilePic.jpg`}
                            style={{
                                height: "114px",
                                width: "114px",
                                borderRadius: "114px",
                            }}
                            alt=""
                        />
                        <input
                            type="file"
                            style={{
                                display: "none",
                            }}
                            ref={this.hiddenFileInput}
                            name="myFile"
                            onChange={this.state.isEditEnabled ? this.handleFileChange : null}
                        />
                    </div>

                    {this.state.isEditEnabled ? (
                        <div className="editIcon" onClick={this.handleClick}>
                            <Icon className="icon-style" name="edit" inverted size="small" />
                        </div>
                    ) : null}

                    <div className={`ProfileDetails ${this.props.sidebarExpanded ? "" : "left__shift"}`}>
                        <div className="profile-top-section">
                            <div className="ProfileSection">
                                <div className="Section">
                                    <p className="LabelStyle" style={{ marginTop: "3%" }}>
                                        Company
                                    </p>
                                    <div className="field">
                                        <p style={{ paddingTop: "4%", fontWeight: "bolder" }}>-</p>
                                        <Input
                                            className={this.state.isEditEnabled ? "inputEditable" : "inputStyle"}
                                            id="company_input"
                                            transparent={true}
                                            style={{ width: "100%" }}
                                            readOnly={!this.state.isEditEnabled}
                                            maxLength="40"
                                            type="text"
                                            title={this.state.companyName.length > 40 ? `${this.state.companyName}` : null}
                                            value={this.truncatedName(this.state.companyName.split(""))}
                                            onChange={(e) => this.handleChange(e, "companyName")}
                                        />
                                    </div>
                                </div>
                                <div className="Section">
                                    <p className="LabelStyle" style={{ marginTop: "3%" }}>
                                        Your Name
                                    </p>
                                    <div className="field" style={!this.state.isEditEnabled ? { border: "none" } : {}}>
                                        <p style={{ paddingTop: "4%", fontWeight: "bolder" }}>-</p>
                                        <Input
                                            className={this.state.isEditEnabled ? "inputEditable" : "inputStyle"}
                                            transparent={true}
                                            readOnly={!this.state.isEditEnabled}
                                            type="text"
                                            style={{ width: "100%" }}
                                            value={this.state.profileName}
                                            onChange={(e) => this.handleChange(e, "profileName")}
                                        />
                                    </div>
                                </div>
                                <div className="Section">
                                    <p className="LabelStyle" style={{ marginTop: "3%" }}>
                                        Email
                                    </p>
                                    <div className="field" style={!this.state.isEditEnabled ? { border: "none" } : {}}>
                                        <p style={{ paddingTop: "4%", fontWeight: "bolder" }}>-</p>
                                        <Input
                                            className={`InputDemo`}
                                            transparent={true}
                                            readOnly={true}
                                            type="text"
                                            style={{ width: "100%" }}
                                            value={this.state.email}
                                            onChange={(e) => this.handleChange(e, "email")}
                                        />
                                    </div>
                                </div>
                                <div className="Section">
                                    <p className="LabelStyle" style={{ marginTop: "3%" }}>
                                        Password
                                    </p>
                                    <div className="field" style={!this.state.isEditEnabled ? { border: "none" } : {}}>
                                        <p style={{ paddingTop: "4%", fontWeight: "bolder" }}>-</p>
                                        <Popup
                                            trigger={
                                                <Input
                                                    className={this.state.isEditEnabled ? "inputEditable" : "inputStyle"}
                                                    transparent={true}
                                                    readOnly={!this.state.isEditEnabled}
                                                    type={this.state.showNewPassword ? "text " : "password"}
                                                    style={{ width: "100%" }}
                                                    value={this.state.password}
                                                    onChange={(e) => this.handleChange(e, "password")}
                                                />
                                            }
                                            header="Password hint"
                                            content="Between 8 and 30 characters in length.
                                    Use at least a special character  (EG -!#$%&'()*+,-./:;<=>?@[\]^_`{|}~).
                                    Should be different from your email id and username.
                                    Should be different from your old password."
                                            position="left center"
                                            on="focus"
                                            inverted
                                        />
                                        {this.state.isEditEnabled && this.state.password.match(/[^*]+/gm) && (
                                            <span className="eye__btn" onClick={() => this.showNewPassword()}>
                                                {this.state.showNewPassword ? (
                                                    <EyeOpen className="eye__icon" title="Hide Password" />
                                                ) : (
                                                    <EyeClose className="eye__icon" title="Show Password" />
                                                )}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className="Section">
                                    <p className="LabelStyle" style={{ marginTop: "3%" }}>
                                        Timezone
                                    </p>
                                    <div className="field">
                                        <p style={{ paddingTop: "4%", fontWeight: "bolder" }}>-</p>
                                        <Select
                                            value={this.state.timezone}
                                            className="Dropdown"
                                            components={{
                                                IndicatorsContainer,
                                            }}
                                            styles={customStyles}
                                            menuPlacement="top"
                                            onChange={this.handleDropDownChange}
                                            options={this.fetchTimezoneList()}
                                            isDisabled={!this.state.isEditEnabled}
                                        />
                                    </div>
                                </div>
                            </div>
                            {this.state.linked_companies.length ? (
                                <div className="switchSection scrollable-list">
                                    <Dropdown
                                        text="Switch Company"
                                        icon="angle down"
                                        className="switch_drdn profile_step3"
                                        closeOnChange={false}
                                        onBlur={() => this.setState({ searchCompany: "" })}>
                                        <Dropdown.Menu style={{ right: 0, left: "auto" }}>
                                            <div className="company-menu">
                                                <Dropdown.Item>
                                                    <div className="profile-search">
                                                        <span className="profile-search-icon">
                                                            <SearchIcon />
                                                        </span>
                                                        <input
                                                            type="text"
                                                            onChange={(e) => {
                                                                this.searchCompanyName(e);
                                                            }}
                                                            onKeyUp={(e) => {
                                                                if (e.keyCode === 32) {
                                                                    e.target.value = e.target.value + " ";
                                                                    e.stopPropagation();
                                                                }
                                                            }}
                                                            onClick={(e) => e.stopPropagation()}
                                                            placeholder="Search"
                                                            className="search"
                                                            value={this.state.searchCompany}
                                                        />
                                                        {this.state.searchCompany.length !== 0 && (
                                                            <span
                                                                className="clear-icon"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    this.setState({ searchCompany: "" });
                                                                }}>
                                                                <span className="svg__wrapper">
                                                                    <CloseIcon />
                                                                </span>
                                                            </span>
                                                        )}
                                                    </div>
                                                </Dropdown.Item>
                                                {this.filteredSearch(this.state.linked_companies).map((company, idx) => (
                                                    <Dropdown.Item
                                                        key={company.id}
                                                        title={company.name.length > 50 ? company : null}
                                                        onClick={(e) => {
                                                            if (!company.name.includes("No company found"))
                                                                this.setState({ showModal: true, selectedAccount: company.name });
                                                            else e.stopPropagation();
                                                        }}
                                                        className={company.name == this.props.company.company_name ? "drdn-item selected" : "drdn-item"}>
                                                        {company.name.length > 50 ? company.name.substring(0, 50 - 3) + "..." : company.name}
                                                    </Dropdown.Item>
                                                ))}
                                            </div>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            ) : null}
                        </div>
                        <div className="Section">
                            <p className="LabelStyle help__label" style={{ marginTop: "3%" }}>
                                Interactive Help
                            </p>
                            <div className="field ">
                                <Checkbox
                                    toggle
                                    disabled={!this.state.isEditEnabled}
                                    checked={this.state.interactiveHelp_enabled == 1}
                                    onChange={() => this.setState({ interactiveHelp_enabled: !this.state.interactiveHelp_enabled })}
                                    className={`${this.props.sidebarExpanded ? "toggle__btn" : "toggle__btn1"}`}
                                    // className="toggle-style"
                                />
                            </div>
                        </div>
                        {this.renderSwitchModal()}
                        <div className="ButtonSection">
                            <div
                                className={!this.state.isEditEnabled ? "ButtonStyles profile_step2" : "ButtonStyles"}
                                style={
                                    !this.state.isEditEnabled
                                        ? {
                                              marginLeft: "32%",
                                          }
                                        : {}
                                }
                                onClick={() => {
                                    this.setState(
                                        {
                                            isEditEnabled: !this.state.isEditEnabled,
                                        },
                                        () => {
                                            this.setState({
                                                companyName:
                                                    this.props.company.company_name !== ""
                                                        ? this.props.company.company_name
                                                        : this.props.company.company_identifier,
                                                profileName: this.props.company.user_name,
                                                userName: this.props.userName,
                                                email: this.props.company.userEmail,
                                                password: "*******",
                                                // timezone: Number.parseFloat(this.props.company.user_timezone).toFixed(1),
                                                timezone: this.fetchTimezone(),
                                            });
                                        },
                                    );
                                }}>
                                {this.state.isEditEnabled ? "Close" : "Edit"}
                            </div>
                            {this.state.isEditEnabled ? (
                                <div className="ButtonStyles" onClick={this.state.isEditEnabled ? this.onSave : null}>
                                    Save
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        imageUploadedUrl: state.globalReducer.imageUploadedUrl,
        all_companies: state.globalReducer.all_companies,
        company: state.globalReducer.company,
        newAccessToken: state.globalReducer.newAccessToken,
        interactive_help_enabled: state.globalReducer.interactive_help_enabled,
        sidebarExpanded: state.globalReducer.sidebarExpanded,
    };
};

export default connect(mapStateToProps, {
    UpdateUserDetails,
    UpdateCompanyDetails,
    UploadPhoto,
    switchAccountDetails,
    fetchMetaData,
    isSwitchCompanyAvailable,
})(Profile);
